import React from 'react';
import {Route,Redirect} from 'react-router-dom';
import {connect} from "react-redux";

const PublicRoute = ({component : Component,restricted,...rest}) => {
    const logInState = rest.isUserLoggedIn;
    return (
    <Route {...rest} render={
        props =>
            logInState && restricted ?
             <Redirect to="/surveys"/> : <Component {...props}/>
    }/>);
};

function mapStateToProps(state) {
    return {
        isUserLoggedIn: state.user.loggedIn
    };
}

export default connect(mapStateToProps)(PublicRoute);